// TODO убрать в UIData
export var REASONS_LIST = [
    {
        label: "Оповещения о сбоях не приходят на почту",
        id: 1,
    },
    {
        label: "Данные не поступают в систему",
        id: 2,
    },
    {
        label: "Статистика рассчитывается некорректно",
        id: 3,
    },
    {
        label: "Проблемы с добавлением/редактированием/удалением объектов",
        id: 4,
    },
    {
        label: "Проблемы с расчетом статистики на исторических данных",
        id: 5,
    },
    {
        label: "Проблемы с выгрузкой отчета",
        id: 6,
    },
    {
        label: "Не открывается Веб-интерфейс",
        id: 7,
    },
    {
        label: "Не работают кнопки в Веб-интерфейсе",
        id: 7,
    },
    {
        label: "Другое",
        id: 7,
    },
];
